import React from "react";
import { useNavigate,useLocation } from "react-router-dom";
import 
{
    Box,
    Typography,
    Button,
    Grid,
    TextField,
    Select,
    MenuItem,
    FormControl,
    Snackbar,
    Alert,
    InputLabel
} from '@mui/material';
import { legalTeamApi } from "../../api/api";
import { useState } from "react";

const ApprovePriceUpdateByTeam=()=>
{

     const navigate = useNavigate();
      const location = useLocation();
      const propertyData = location.state;
      
    
      const [openSnackbar, setOpenSnackbar] = useState(false);
      const [snackbarMessage, setSnackbarMessage] = useState("");
      const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    const [status, setStatus] = useState("Approved");
    
      const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
      };
    
      const handleStatusChange = (event) => {
        setStatus(event.target.value);
      };
    
      const formData = new FormData();
      formData.append("propertyId", propertyData.marketData.id);
      formData.append("Status", status);
    
      const handleApprove = async () => {
        try {
          const response = await legalTeamApi.approvePriceUpdateByTeam(formData);
      
          setSnackbarMessage("Property status updated successfully!");
          setSnackbarSeverity("success");
          setOpenSnackbar(true);
        } catch (error) {
          console.log(error);
          setSnackbarMessage("Failed to update property status.");
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
        }
      };
    
      const handleCancel = () => {
        navigate(-1); // Go back
      };

      return(
        <Box sx={{ p: 4 }}>
         <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select value={status} onChange={handleStatusChange}>
              <MenuItem value="Approved">Approved</MenuItem>
              <MenuItem value="Rejected">Rejected</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* Buttons */}
        <Grid item xs={12} sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
          <Button variant="contained" color="success" onClick={handleApprove}>
            Approve Property
          </Button>
          <Button variant="outlined" color="error" onClick={handleCancel}>
            Cancel
          </Button>
        </Grid>
      </Grid>

      {/* Snackbar Notification */}
      <Snackbar open={openSnackbar} autoHideDuration={4000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      </Box>
      )
    


}

export default ApprovePriceUpdateByTeam;